import React from "react";

const CommonTextField = ({ title, placeholder, type, value, onChange }) => {
  return (
    <>
      <p className="mb-1">{title}</p>
      <input
        placeholder={placeholder ?? title}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full p-3 rounded-lg mb-2 border border-[#5153F5]"
      />
    </>
  );
};

export default CommonTextField;
